
import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

interface EvaluatingToolbarProps {
  count: number | undefined;
  onAddCustom: () => void;
}

const getCountLabel = (count: number | undefined): string => {
  if (count === undefined) return '';

  return `${count} ${count === 1 ? 'element' : 'elements'} under evaluation`;
};

const EvaluatingToolbar = ({ count, onAddCustom }: EvaluatingToolbarProps) => (
  <Stack
    direction="row"
    sx={{ mb: 1.5, alignItems: 'flex-end', justifyContent: 'space-between' }}
  >
    <p className="text-sm text-gray-700" data-testid="evaluating-count">
      {getCountLabel(count)}
    </p>
    <Button
      variant="reserve-outlined"
      size="md"
      iconBefore={<Icons.PlusThin className="size-5" aria-hidden="true" />}
      onClick={onAddCustom}
      data-testid="add-custom-button"
    >
      Add custom
    </Button>
  </Stack>
);

export default EvaluatingToolbar;
